import Vue from 'vue';
import VueI18n from 'vue-i18n';
import UIkit from 'uikit';
import Flatpickr from 'flatpickr';
import locales from './locales';

Vue.use(VueI18n);

export const LOCALE = 'de';

const locale = locales[LOCALE] || {};
const i18n = new VueI18n({
  locale: LOCALE,
  silentTranslationWarn: true,
  messages: {
    [LOCALE]: locale.messages || {},
  },
  numberFormats: {
    [LOCALE]: locale.numberFormats || {},
  },
  dateTimeFormats: {
    [LOCALE]: locale.dateTimeFormats || {},
  },
});

if (module.hot) {
  module.hot.accept([`./locales/${LOCALE}.js`], () => {
    // eslint-disable-next-line
    i18n.setLocaleMessage(LOCALE, require(`./locales/${LOCALE}`).default)
  });
}

UIkit.modal.labels = {
  ok: i18n.t('dialogs.ok'),
  cancel: i18n.t('dialogs.cancel'),
};

// eslint-disable-next-line
Flatpickr.localize(require(`flatpickr/dist/l10n/${LOCALE}`)[LOCALE])

export default i18n;



// WEBPACK FOOTER //
// ./i18n.js